import React from "react";
import TopNav from "../layouts/TopNav";
import { Link, Outlet } from "react-router-dom";
import "../Styles/Setting.css";

const Settings = () => {
  return (
    <div className="board">
      <TopNav title="Settings" />

      <div className="settingTop py-4">
        <ul>
          <li>
            <Link to="/dashboard/settings">Account</Link>
          </li>
          <li>
            <Link to="/dashboard/settings/staff">Staff & Branch</Link>
          </li>
          <li>
            <Link to="/dashboard/settings/permissions">Permissions</Link>
          </li>
          <li>
            <Link to="/dashboard/settings/changepassword">Password</Link>
          </li>
        </ul>
      </div>
      <Outlet />
    </div>
  );
};

export default Settings;
